module.exports = __webpack_public_path__ + "img/index03.38fbe596.webp";